<template>
    <div>
        <h2 class="text-28 lg:text-36 text-navy font-bold mt-10 mb-2" id="pricing_options">Pricing</h2>

        <!-- single pricing option -->
        <div v-if="data.pricing_option2.is_active && !data.pricing_option1.is_active && !data.pricing_option3.is_active"
            class="flex w-full justify-center">

            <proposal-pricing-option
                v-if="data.pricing_option2.is_active" 
                v-model="localValue"
                :data="data.pricing_option2"
                :selectable="false"
            />
        </div>

        <!-- multiple pricing options -->
        <div v-else class="flex flex-col justify-between gap-y-8 items-center lg:flex-row lg:gap-x-8 mt-4">                   
            <proposal-pricing-option
                v-if="data.pricing_option1.is_active" 
                v-model="localValue"
                :data="data.pricing_option1"
            />

            <proposal-pricing-option
                v-if="data.pricing_option2.is_active" 
                v-model="localValue"
                :data="data.pricing_option2"
                :recommended="true"
            />

            <proposal-pricing-option
                v-if="data.pricing_option3.is_active" 
                v-model="localValue"
                :data="data.pricing_option3"
            />
        </div>
    </div>
</template>

<script>
import ProposalPricingOption from "./proposal-31-pricing-option";

export default {
    components: {
        ProposalPricingOption,
    },
    props: {
        value: {
			type: Number,
			required: true
		},
        data: {
			type: Object,
			required: true
		},
    },
    data() {
        return {
            localValue: this.value
        }
    },
    watch: {
        value(newValue) {
            this.setLocalValue(newValue);
        },
        localValue(newValue) {
            this.updateValue(newValue);
        },
    },
    methods: {
        setLocalValue(newValue) {
            this.localValue = newValue;
        },
        updateValue(newValue) {
            this.$emit('input', newValue);
        },
    }
}
</script>